import { render } from "./QVPList.vue?vue&type=template&id=cc3bef10&scoped=true"
import script from "./QVPList.vue?vue&type=script&lang=js"
export * from "./QVPList.vue?vue&type=script&lang=js"

import "./QVPList.vue?vue&type=style&index=0&id=cc3bef10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3bef10"]])

export default __exports__